var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartFwp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "-4 -4 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E6",
  d: "M5.133 12.514H1.758V16H0V7.469h5.555v1.424H1.758v2.203h3.375zm8.086 1.025 1.148-6.07h1.752L14.227 16h-1.77l-1.389-5.707L9.68 16H7.91L6.018 7.469H7.77l1.154 6.058L10.33 7.47h1.488zm5.607-.545V16h-1.758V7.469h3.328q.962 0 1.69.351.73.352 1.123 1 .393.646.393 1.473 0 1.254-.859 1.978-.858.723-2.376.723h-1.54zm0-1.424h1.57q.698 0 1.064-.328t.366-.937q0-.627-.369-1.014c-.369-.387-.586-.39-1.02-.398h-1.61v2.677z"
})));
export default SvgChartFwp;